/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Out_Reason_For_PackagingInputs */

const vi_scl_out_reason_for_packaging = /** @type {(inputs: Scl_Out_Reason_For_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất đi đóng gói`)
};

/**

* @param {Scl_Out_Reason_For_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_out_reason_for_packaging = /** @type {((inputs?: Scl_Out_Reason_For_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Out_Reason_For_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_out_reason_for_packaging(inputs)
});